import { Alert, Button, Col, Panel, Row } from 'react-bootstrap'

interface IProps {
    id: number,
    imei: string,
    gpsNumber: number,
    vendor: string,
    onConfirm: () => void,
    onCancel: () => void
}

const Delete = (props: IProps) => {
    return (
        <Panel bsStyle='danger'>
            <Panel.Heading>Confirm Deletion of GPS Device</Panel.Heading>
            <Panel.Body>
                <Alert bsStyle='danger' bsSize='sm'>
                    <div style={{ marginBottom: 5 }}>Please confirm that you would like to delete the following device.</div>
                    <div><strong>WARNING! This is NOT reversible!</strong></div>
                </Alert>

                <Row>
                    <Col xs={12} lg={3}>IMEI:</Col>
                    <Col xs={12} lg={7}>{props.imei}</Col>
                </Row>

                <Row>
                    <Col xs={12} lg={3}>GPS #:</Col>
                    <Col xs={12} lg={7}>{props.gpsNumber}</Col>
                </Row>

                <Row>
                    <Col xs={12} lg={3}>Vendor:</Col>
                    <Col xs={12} lg={7}>{props.vendor}</Col>
                </Row>
            </Panel.Body>
            <Panel.Footer>
                <Button bsStyle='danger' onClick={props.onConfirm}>Confirmed</Button>&nbsp;
                <Button onClick={props.onCancel}>Cancel</Button>
            </Panel.Footer>
        </Panel>
    );
}

export default Delete;